<section
  class="flex h-full w-full flex-col overflow-hidden bg-white text-gray-900"
  role="dialog"
  [attr.aria-label]="'link_existing_chat' | translate"
>
  <header class="flex shrink-0 items-center gap-3 border-b border-gray-100 px-4 py-3">
    <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-blue-50 text-blue-600">
      <app-icon>chat_bubble_outline</app-icon>
    </div>
    <div class="min-w-0 flex-1">
      <h2 class="m-0 text-base font-bold leading-6 text-gray-900">{{ 'link_existing_chat' | translate }}</h2>
    </div>
    <button
      type="button"
      class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-gray-500 hover:bg-gray-100"
      [attr.aria-label]="'close' | translate"
      (click)="onCancel()"
    >
      <app-icon>close</app-icon>
    </button>
  </header>

  <div class="shrink-0 border-b border-gray-100 px-4 py-3">
    <div class="relative">
      <app-icon
        class="pointer-events-none absolute left-3 top-1/2 !h-5 !w-5 -translate-y-1/2 !text-[20px] !leading-5 text-gray-400"
      >
        search
      </app-icon>
      <input
        type="search"
        class="block h-11 w-full rounded-lg border border-gray-200 bg-white py-2 pl-10 pr-3 text-sm text-gray-900 outline-none placeholder:text-gray-400 focus:border-blue-400"
        [ngModel]="search"
        (ngModelChange)="onSearchChange($event)"
        [placeholder]="'search' | translate"
      />
    </div>
  </div>

  <div class="crm-scroll min-h-0 flex-1 overflow-y-auto px-2 py-2" (scroll)="onScroll($event)">
    @if (loading) {
      <div class="flex h-full min-h-48 items-center justify-center">
        <app-loader />
      </div>
    } @else {
      @for (chat of chats; track chat.id) {
        <app-chat-list-item class="cursor-pointer" [chat]="chat" [selected]="false" (click)="onSelectChat(chat)" />
      } @empty {
        <div class="flex h-full min-h-48 flex-col items-center justify-center rounded-xl bg-gray-50 px-4 py-8 text-center">
          <app-icon class="mb-2 !text-[28px] text-gray-300">search_off</app-icon>
          <p class="m-0 text-sm font-medium text-gray-600">{{ 'no_dialog_found' | translate }}</p>
        </div>
      }

      @if (loadingMore) {
        <app-loader type="indeterminate" />
      }
    }
  </div>
</section>
